
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const ChartBarsCircleIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M31.5 54C33.433 54 35 55.567 35 57.5V62.5C35 64.433 33.433 66 31.5 66C29.567 66 28 64.433 28 62.5V57.5C28 55.567 29.567 54 31.5 54Z" fill="#161617"/>
<path d="M68 41.5C68 39.567 66.433 38 64.5 38C62.567 38 61 39.567 61 41.5V62.5C61 64.433 62.567 66 64.5 66C66.433 66 68 64.433 68 62.5V41.5Z" fill="#161617"/>
<path d="M53.5 30C55.433 30 57 31.567 57 33.5V62.5C57 64.433 55.433 66 53.5 66C51.567 66 50 64.433 50 62.5V33.5C50 31.567 51.567 30 53.5 30Z" fill="#161617"/>
<path d="M46 47.5C46 45.567 44.433 44 42.5 44C40.567 44 39 45.567 39 47.5V62.5C39 64.433 40.567 66 42.5 66C44.433 66 46 64.433 46 62.5V47.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M8 48C8 25.9086 25.9086 8 48 8C70.0914 8 88 25.9086 88 48C88 70.0914 70.0914 88 48 88C25.9086 88 8 70.0914 8 48ZM48 15C29.7746 15 15 29.7746 15 48C15 66.2254 29.7746 81 48 81C66.2254 81 81 66.2254 81 48C81 29.7746 66.2254 15 48 15Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M64.5 54C62.567 54 61 55.567 61 57.5V62.5C61 64.433 62.567 66 64.5 66C66.433 66 68 64.433 68 62.5V57.5C68 55.567 66.433 54 64.5 54Z" fill="#161617"/>
<path d="M28 41.5C28 39.567 29.567 38 31.5 38C33.433 38 35 39.567 35 41.5V62.5C35 64.433 33.433 66 31.5 66C29.567 66 28 64.433 28 62.5V41.5Z" fill="#161617"/>
<path d="M42.5 30C40.567 30 39 31.567 39 33.5V62.5C39 64.433 40.567 66 42.5 66C44.433 66 46 64.433 46 62.5V33.5C46 31.567 44.433 30 42.5 30Z" fill="#161617"/>
<path d="M50 47.5C50 45.567 51.567 44 53.5 44C55.433 44 57 45.567 57 47.5V62.5C57 64.433 55.433 66 53.5 66C51.567 66 50 64.433 50 62.5V47.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48ZM48 15C66.2254 15 81 29.7746 81 48C81 66.2254 66.2254 81 48 81C29.7746 81 15 66.2254 15 48C15 29.7746 29.7746 15 48 15Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 48C11.5 68.1584 27.8416 84.5 48 84.5C68.1584 84.5 84.5 68.1584 84.5 48C84.5 27.8416 68.1584 11.5 48 11.5C27.8416 11.5 11.5 27.8416 11.5 48Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
